import { useMutation } from '@platform/api-client';
import { Button } from '@platform/design-system';
import type { ShippingClient } from '@platform/openapi';
import { RefreshCw } from 'lucide-react';
import { usePageContext } from '../usePageContext.ts';

export type RefreshTrackingProps = { shipping: ShippingClient; shipmentId: string };

export const RefreshTracking = ({ shipping, shipmentId }: RefreshTrackingProps) => {
  const { t, notify, describeError } = usePageContext();
  const refresh = useMutation({
    mutationFn: () => shipping.post('/admin/shipments/{id}/refresh', { path: { id: shipmentId } }),
    onSuccess: ({ outcome }) => {
      notify(outcome === 'queued' ? t('orders.refreshQueued') : t('orders.refreshNotFollowed'));
    },
  });
  return (
    <>
      <Button
        variant="ghost"
        icon={<RefreshCw size={20} aria-hidden="true" />}
        disabled={refresh.isPending}
        onClick={() => {
          refresh.mutate();
        }}
      >
        {t('orders.refresh')}
      </Button>
      {refresh.isError ? <p role="alert">{describeError(refresh.error)}</p> : null}
    </>
  );
};
